import { createContext, useContext } from 'react';
export const TechContext = createContext({ esTecnico: false, proyectoTech: null });
export const useTech = () => useContext(TechContext);